define('common/views/notice_view_mdnotice',['require','exports','module','base/view','lodash','jquery','backbone','i18n','env','services/auth/info','mdnotice'],function (require, exports, module) {
  'use strict';

  var View = require('base/view'),
    _ = require('lodash'),
    $ = require('jquery'),
    Backbone = require('backbone'),
    i18n = require('i18n'),
    Config = require('env'),
    AuthInfo = require('services/auth/info'),
    authInfo = new AuthInfo(),
    mdNotice = require('mdnotice');

  var Header = Backbone.View.extend({
    userLang: i18n.lng(),
    initialize: function () {
      this.userLang = i18n.lng();
    },

    render: function () {
      var self = this;
      mdNotice.init({
        el: '#noticeContainer',
        url: Config.signupBackendUrl + '/notice/landings',
        cors: true,
        userData: {
          user: authInfo.getUserName(),
          userType: authInfo.getRolId(),
          product: 'landings',
          name: authInfo.getUserName(),
          lang: this.userLang,
        },
      });
      return this;
    },
  });

  module.exports = Header;
});

